module.exports = __webpack_public_path__ + "static/media/haltech.b2dded25.png";